import Modal from '@material-ui/core/Modal'
import React, { FC, useEffect, useState } from 'react'

import { CrossIcon } from 'uiKit/icons/CrossIcon'

import * as S from './RelatedResourcesModal.style'
import { CButton } from '../CButton'
import { DaxUsagesResponse } from 'tabs/data/api/generated'
import { RelatedResource } from './RelatedResource'

type RelatedResourcesModalProps = {
  open: boolean
  data: DaxUsagesResponse['usages']
  submitLabel: string
  message?: string
  onClose: () => void
  onSubmit: () => Promise<void>
}

export const RelatedResourcesModal: FC<RelatedResourcesModalProps> = ({
  open,
  data,
  submitLabel,
  message = 'The element is used in the following places:',
  onClose,
  onSubmit,
}) => {
  const { questions, tables, metrics } = data

  const [loading, setLoading] = useState(false)
  const handleDelete = async () => {
    try {
      setLoading(true)
      await onSubmit()
    } catch (e) {
      setLoading(false)
      throw e
    }
  }

  useEffect(() => {
    if (open) setLoading(false)
  }, [open])

  if (!open) return null

  return (
    <Modal open onClose={onClose}>
      <S.Container>
        <S.Title>WARNING !</S.Title>
        <S.SubTitle>{message}</S.SubTitle>
        <S.IconWrap onClick={onClose}>
          <CrossIcon color={'var(--color-spun-pearl-grey)'} />
        </S.IconWrap>

        <S.ResourceWrap>
          <RelatedResource label="Questions" items={questions} link="/admin/bot/1/nlp/questions" />
          <RelatedResource label="Tables" items={tables} />
          <RelatedResource label="Metrics" items={metrics} />
        </S.ResourceWrap>

        <S.ButtonsWrap>
          <CButton label="Cancel" color="primary" disabled={loading} onClick={onClose} />
          <CButton label={submitLabel} color="danger" disabled={loading} onClick={handleDelete} />
        </S.ButtonsWrap>
      </S.Container>
    </Modal>
  )
}
